import { FunctionFactory } from 'survey-core';
import { ComfortLevel } from '../quiz/comfort';
import { tSurvey } from '../i18n/survey';
import { makeSplashHeader } from './SplashHeader';

const comfortSplashHtml = `
<div class="new-quote-container centered"> 
  <div class="splash-icon">{comfortSplashIcon}</div>
  <div class="splash-header">
    <h1>{comfortSplashTitle}</h1>
    <div class="quote">
      {comfortQuote}
    </div>
  </div>
</div>`;

const comfortSplashExpression = {
  name: "comfortQuote",
  expression: "renderComfortQuote({comfort})",
};

function renderComfortQuote(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch(params[0] as ComfortLevel) {
    case ComfortLevel.Never:
      return tSurvey("splash.comfort.quote.never");
    case ComfortLevel.Learning:
    case ComfortLevel.Reguarly:
      return tSurvey("splash.comfort.quote.learning");
    case ComfortLevel.CantDo:
      return tSurvey("splash.comfort.quote.cantDo");
  }
}

FunctionFactory.Instance.register("renderComfortQuote", renderComfortQuote);

function renderComfortQuoteIcon(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch(params[0] as ComfortLevel) {
    case ComfortLevel.Never:
    case ComfortLevel.Learning:
    case ComfortLevel.Reguarly:
      return `🙌`;
    case ComfortLevel.CantDo:
      return `🔀`;
  }
}

FunctionFactory.Instance.register("renderComfortQuoteIcon", renderComfortQuoteIcon);

function renderComfortQuoteTitle(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch(params[0] as ComfortLevel) {
    case ComfortLevel.Never:
      return tSurvey("splash.comfort.title.never");
    case ComfortLevel.Learning:
    case ComfortLevel.Reguarly:
      return tSurvey("splash.comfort.title.learning");
    case ComfortLevel.CantDo:
      return tSurvey("splash.comfort.title.cantDo");
  }
}

FunctionFactory.Instance.register("renderComfortQuoteTitle", renderComfortQuoteTitle);

const comfortSplashTitleExpression = {
  name: "comfortSplashTitle",
  expression: "renderComfortQuoteTitle({comfort})",
};

const comfortSplashIconExpression = {
  name: "comfortSplashIcon",
  expression: "renderComfortQuoteIcon({comfort})",
};

const comfortSplashElement = {
  name: 'comfort-splash',
  type: 'html',
  html: comfortSplashHtml,
}

const ComfortSplashHeader = makeSplashHeader("splash.headers.comfort");

export {
  comfortSplashElement,
  comfortSplashExpression,
  comfortSplashIconExpression,
  comfortSplashTitleExpression,
  ComfortSplashHeader,
}
